module.exports = __webpack_public_path__ + "static/MapAbove500px-e63a22d546d5cda95bd6f911b9dfd5a1.svg";